import { IotTypographyError } from "@core/presentation/components/general/typography/iot-typography-error.component";
import { IotTypographyParagraph } from "@core/presentation/components/general/typography/iot-typography-paragraph.component";
import { IotTypographyText } from "@core/presentation/components/general/typography/iot-typography-text.component";
import { IotTypographyTitle } from "@core/presentation/components/general/typography/iot-typography-title.component";
import type { GetProps } from "antd";
import { Typography } from "antd";
import type { FC } from "react";

export type IotTypographyProps = GetProps<typeof Typography>;

export const IotTypography: FC<IotTypographyProps> & {
    Title: typeof IotTypographyTitle;
    Text: typeof IotTypographyText;
    Error: typeof IotTypographyError;
    Paragraph: typeof IotTypographyParagraph;
} = (props) => <Typography {...props} />;

IotTypography.Title = IotTypographyTitle;
IotTypography.Text = IotTypographyText;
IotTypography.Error = IotTypographyError;
IotTypography.Paragraph = IotTypographyParagraph;
